import { LoginPayload, LoginResponse } from "../../../../models/User";
import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";

export async function forgotPasswordAuthCheck(data: { token: string }) {
  const res = await ApiClient.post(`/ForgotPasswordAuthCheck`, data);
  return res.data;
}

export const useForgotPasswordAuthCheck = mutationWrapper(
  forgotPasswordAuthCheck
);
